import { motion } from "framer-motion";
import { UtensilsCrossed, Landmark, Bot } from "lucide-react";

const projects = [
  {
    icon: UtensilsCrossed,
    title: "AI-Powered Restaurant Management Platform",
    desc: "A multilingual AI-integrated POS and back-office system featuring predictive stock control, intelligent order optimization, and real-time operational analytics. Impact: 32% operational efficiency increase, automated inventory forecasting, and data-driven performance insights.",
  },
  {
    icon: Landmark,
    title: "Intelligent Workflow Automation for Finance",
    desc: "AI-driven document processing and risk scoring engine designed to accelerate compliance and financial operations. Impact: 65% faster document review, reduced human error, and secure AI-based compliance validation.",
  },
  {
    icon: Bot,
    title: "Custom AI Agent Platform",
    desc: "Autonomous digital assistants built for internal enterprise workflows, streamlining operations and enabling structured data feedback loops. Impact: reduced repetitive tasks, increased team productivity, and continuous performance optimization.",
  },
];

const ProjectsSection = () => {
  return (
    <section id="projects" className="py-24 md:py-32 bg-gradient-hero">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-[0.2em] text-primary mb-3 font-body">
            Selected AI & Digital Engineering Projects
          </p>
          <h2 className="text-3xl md:text-5xl font-bold font-display">
            Proven <span className="text-gradient-red">Impact</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {projects.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
              className="text-center"
            >
              <div className="w-16 h-16 rounded-full bg-glass border border-glass mx-auto mb-5 flex items-center justify-center">
                <p.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-lg font-display font-semibold mb-3 text-foreground">
                {p.title}
              </h3>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {p.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;